import { USER_ROLES } from 'utils/constants';

export const FILTER_BY_OPTIONS = [
    {
        text: 'All',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: '',
        key: 0
    },{
        text: 'Admins',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'admins',
        rolesThatHaveAccess: [USER_ROLES.ADMIN],
        key: 1
    },{
        text: 'Users',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'employees',
        rolesThatHaveAccess: [USER_ROLES.ADMIN],
        key: 2
    },{
        text: 'Created by Me',
        sortBy: 'modified',
        sortDirection: true,
        filterBy: 'creator',
        key: 3
    }
];

export const SORT_BY_OPTIONS = [
    {
        text: 'Recently Edited',
        sortBy: 'modified',
        sortDirection: true,
        key: 0
    },{
        text: 'Last Name (a-z)',
        sortBy: 'lastName',
        sortDirection: false,
        key: 1
    },{
        text: 'Last Name (z-a)',
        sortBy: 'lastName',
        sortDirection: true,
        key: 2
    },{
        text: 'First Name (a-z)',
        sortBy: 'firstName',
        sortDirection: false,
        key: 3
    },{
        text: 'First Name (z-a)',
        sortBy: 'firstName',
        sortDirection: true,
        key: 4
    }
];



// WEBPACK FOOTER //
// ./src/containers/UsersPage/UsersIndividualsPage/constants.js